export enum PriceSettingEnum {
    AllowNone = 0,
    AllowSuggestedRetailPrice = 1,
    AllowNetPrice = 2,
    AllowAll = 3
}